import { render, staticRenderFns } from "./detailsPage.vue?vue&type=template&id=001f10b5&scoped=true"
import script from "./detailsPage.vue?vue&type=script&lang=js"
export * from "./detailsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f10b5",
  null
  
)

export default component.exports